import api from '../../../apis/api';

const getOpenJobs = async () => {
  const response = await api.get('job/open', {});

  if (response.data) {
    return response.data;
  }

  return [];
};

export default getOpenJobs;
